import React from "react";

import apple from "assets/graphics/icons/apple--black.svg";
import android from "assets/graphics/icons/android--black.svg";
import bg_get_connected_phone from "assets/graphics/pictures/get_connected_phones.png?50";

import "features/new/get-connected/view.scss";

const GetConnectedView = () => (
  <section className="main__get-connected" id="get-connected">
    <div className="get-connected__img__container">
      <img
        className="main__animation--fade-in"
        src={bg_get_connected_phone}
        alt="phones"
      />
    </div>

    <div className="get-connected__container">
      <div className="get-connected__text">
        <h2 className="get-connected__headline main__animation--fade-in">
          Get Connected
        </h2>

        <p className="get-connected__description main__animation--fade-in">
          Our app facilitates seamless digital and in-person connections. We use
          real time feedback on events, members and applicants to constantly
          shape a community that evolves with you.
        </p>

        <div className="portal__container portal__get-connected">
          <p className="portal__information">Download Here</p>
          <div className="portal__stores">
            <a
              href="https://apps.apple.com/us/app/parlor-social-club/id1473428896"
              target="blank"
              onClick={() =>
                window.dataLayer.push({ event: "iosVisitedFromGetConnected" })
              }
            >
              <img
                className="portal__store--apple"
                src={apple}
                alt="parlor social club app on ios"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=social.parlor.app"
              target="blank"
              onClick={() =>
                window.dataLayer.push({
                  event: "androidVisitedFromGetConnected",
                })
              }
            >
              <img
                className="portal__store--android"
                src={android}
                alt="parlor social club app on android"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default GetConnectedView;
